import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import ElectronSvg from '../assets/electron-logo.svg';

export const Electron = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-electron" className={cx('sdkIcon', className)} size={size} {...props}>
    <ElectronSvg />
  </LegacyIcon>
);
